// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Cmm","comment":"styles_comment__qKJmP"};